module.exports = __webpack_public_path__ + "static/media/onboarding-banner-image.4867c6e1.png";